import React from 'react';
import { styles } from './MinimalTab.css';
import { useTrackingContext } from '../../Tracking';
import { classNames } from '@jbhi-fi/lanyard-ui/global/utils';

export type MinimalTabProps = {
  className?: string;
  label: string | React.ReactElement;
  onClick: (event: React.MouseEvent) => void;
  isActive: boolean;
  testId?: string;
};

export const MinimalTab = ({ testId, className, label, onClick, isActive }: MinimalTabProps) => {
  const { tracker } = useTrackingContext();

  const handleClick: React.MouseEventHandler = event => {
    if (typeof label === 'string') {
      tracker.trackClick({ label: label, extraData: { moduleName: 'Carousel tab' } });
    }
    onClick?.(event);
  };

  return (
    <button
      className={classNames(styles.container({ isActive }), className)}
      onClick={handleClick}
      data-testid={testId}
    >
      {label}
    </button>
  );
};
